export function Loading() {
  return (
    <div className="loading">
      <div className="loading__spinner"></div>
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
